import type { FC } from "react";
import { PollFormNonCustomAnswerPreview } from "./poll-form-non-custom-answer-preview";

export const PollFormPreset: FC = () => {
  return <PollFormNonCustomAnswerPreview />;
};
